import allianz from '../assets/images/companies-logos/allianz.svg'
import axa_assistance from '../assets/images/companies-logos/axa-assistance.svg'
import colonnade from '../assets/images/companies-logos/colonnade.svg'
import cpp from '../assets/images/companies-logos/cpp.svg'
import csob from '../assets/images/companies-logos/csob.svg'
import das from '../assets/images/companies-logos/das.png'
import direct from '../assets/images/companies-logos/direct.svg'
import fortegra from '../assets/images/companies-logos/fortegra.svg'
import generali from '../assets/images/companies-logos/gcp.svg'
import hellas from '../assets/images/companies-logos/hellas.png'
import hvp from '../assets/images/companies-logos/hvp.png'
import kb from '../assets/images/companies-logos/kb.svg'
import kooperativa from '../assets/images/companies-logos/kooperativa.svg'
import pillow from '../assets/images/companies-logos/pillow.svg'
import slavia from '../assets/images/companies-logos/slavia.svg'
import sv from '../assets/images/companies-logos/sv.svg'
import uniqa_axa from '../assets/images/companies-logos/uniqa-axa2.png'
import uniqa from '../assets/images/companies-logos/uniqa.svg'
import vzp from '../assets/images/companies-logos/vzp.svg'
import { Insurer } from '../enums'

type Logos = Map<Insurer, string>

export const logos: Logos = new Map([
  [Insurer.Uniqa, uniqa],
  [Insurer.Kooperativa, kooperativa],
  [Insurer.Allianz, allianz],
  [Insurer.AllianzSP, allianz],
  [Insurer.Generali, generali],
  [Insurer.GeneraliSK, generali],
  [Insurer.CPP, cpp],
  [Insurer.GeneraliCeskaPojistovna, generali],
  [Insurer.Direct, direct],
  [Insurer.Csob, csob],
  [Insurer.Axa, uniqa_axa],
  [Insurer.Slavia, slavia],
  [Insurer.HvP, hvp],
  [Insurer.PVZP, vzp],
  [Insurer.Fortegra, fortegra],
  [Insurer.Pillow, pillow],
  [Insurer.Colonnade, colonnade],
  [Insurer.AxaAssistance, axa_assistance],
  [Insurer.Das, das],
  [Insurer.KB, kb],
  [Insurer.SV, sv],
  [Insurer.Hellas, hellas]
])